import { Status } from "@/models/user.model";

export const organizationColumns = [
  { name: "Nome", value: "name", filter: true, completeValue: "completeName" },
  { name: "Nº de docentes", value: "countTeachers", filter: false },
  { name: "Nº de alunos", value: "countStudents", filter: false },
  { name: "Nº de cursos publicados", value: "countCourses", filter: false },
  { name: "Status", value: "status", filter: false },
];

export const organizationActions = [
  {
    title: null,
    icon: "hi-solid-pencil",
    type: "edit",
    style: "btn-simple",
    tooltip: "Editar",
  },
  {
    title: null,
    icon: "md-invertcolors-sharp",
    type: "theme",
    style: "btn-simple",
    tooltip: "Tema da organização",
  },
];

export var organizationDropdown = {
  options: [
    { name: "Ativo", code: Status.ACTIVATED },
    { name: "Inativo", code: Status.INACTIVATED },
  ],
  value: null,
};
